import { render, staticRenderFns } from "./BoardFooter.vue?vue&type=template&id=1ee43dd1&scoped=true"
import script from "./BoardFooter.vue?vue&type=script&lang=ts"
export * from "./BoardFooter.vue?vue&type=script&lang=ts"
import style0 from "./BoardFooter.vue?vue&type=style&index=0&id=1ee43dd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee43dd1",
  null
  
)

export default component.exports